import { useMemo } from "react"
import { Box } from "@mui/material"
import {
  ReportingFooter,
  TableHeading,
  topFooterCellStyles,
} from "./DashboardTables"
import { useSelector } from "react-redux"
import CommonTable from "./CommonTable"
import DateRangePicker from "../../Dropdown/DateRangePicker"
import { colors } from "../../../../styles/commonStyles"

export type User = {
  metricName: string
  mtdBudget: number
  mtdActual: number
  variance: number
}
export const HygienistsTable = ({ loading }: { loading?: boolean }) => {
  const hygienistsTableData = useSelector((state: any) => {
    return state.dashboard?.hygienistsData
  })

  const hygienistTableAgg = useSelector((state: any) => {
    return state.dashboard?.hygienistsDataAgg
  })
  const footerStyles: any = {
    align: "center",
    sx: {
      height: "50px",
      border: "1px solid #fff",
      color: "#fff",
      backgroundColor: colors.darkBlue,
      p: 0,
    },
  }
  const hygienistColumn = useMemo<any[]>(
    () => [
      {
        accessorKey: "office",
        header: "Office",
        enableSorting: false,
        Cell: ({ row }: any) => <Box sx={{}}>{row.original.office}</Box>,
        // maxSize: 100,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
            boxShadow: "#00000022 10px 20px",
          },
        }),
        muiTableFooterCellProps: {
          sx: {
            ...footerStyles.sx,
            borderBottomLeftRadius: "5px",
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                height: "100%",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  pl: "40px",
                  justifyContent: "flex",
                }}
              >
                Total
              </Box>
            </Box>
          )
        },
      },
      {
        accessorKey: "provider",
        header: "Provider",
        enableSorting: false,
        // maxSize: 100,
        Cell: ({ row }: any) => <Box>{row.original.provider}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            border: "0.5px solid #E4E4E4",
            boxShadow: "4px 0px 0px 0px rgba(213,214,227, .7)",
          },
        }),
        muiTableFooterCellProps: {
          sx: {
            ...footerStyles.sx,
          },
        },
        Footer: () => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                height: "100%",
              }}
            >
              <Box
                sx={{
                  ...topFooterCellStyles,
                  pl: "40px",
                  justifyContent: "flex",
                }}
              ></Box>
            </Box>
          )
        },
      },
      {
        accessorKey: "net_production",
        header: "Net Prod",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            ${parseFloat(row.original.net_production || 0).toLocaleString()}
          </Box>
        ),

        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            dollar: true,
          }),
      },
      {
        accessorKey: "hours",
        header: "Hours Worked",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.hours}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "production_per_hour",
        header: "Prod Per Hour",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(row.original.production_per_hour || 0).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            dollar: true,
          }),
      },
      {
        accessorKey: "hourly_production_goal",
        header: "Hourly Prod Goal",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.hourly_production_goal || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            dollar: true,
          }),
      },
      {
        accessorKey: "patients_seen",
        header: "Patients Seen",
        enableSorting: true,
        Cell: ({ row }: any) => <Box>{row.original.patients_seen}</Box>,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "production_per_visit",
        header: "Prod Per Visit",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.production_per_visit || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            dollar: true,
          }),
      },
      {
        accessorKey: "production_per_procedure",
        header: "Prod Per Procedure",
        enableSorting: true,
        Cell: ({ row }: any) => (
          <Box>
            $
            {parseFloat(
              row.original.production_per_procedure || 0,
            ).toLocaleString()}
          </Box>
        ),
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            dollar: true,
          }),
      },
      // {
      //   accessorKey: "D1110_adult_prophy",
      //   header: "D1110 Adult Prophy",
      //   enableSorting: true,
      //   Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
      //   muiTableBodyCellProps: () => ({
      //     sx: {
      //       fontWeight: "400",
      //       textTransform: "capitalize",
      //       border: "0.5px solid #E4E4E4",
      //     },
      //   }),
      // },
      {
        accessorKey: "D1110_adult_prophy",
        header: "D1110 Adult Prophy",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "D1120_child_prophy",
        header: "D1120 Child Prophy",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "D4346_gingivitis",
        header: "D4346 Gingivitis",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "D4355_full_mouth_debride",
        header: "D4355 Full Mouth debride",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "fluoride",
        header: "Fluoride",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "D4341_quad_srp",
        header: "D4341 Quad SRP",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "D4342_limited_srp",
        header: "D4342 Limited SRP",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),

        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "srp_count_diagnosed",
        header: "SRP Count Diagnosed",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "srp_conversion_ratio",
        header: "SRP Conversion Ratio",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}%`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },

        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            percent: true,
          }),
      },
      {
        accessorKey: "D4910_perio_maint",
        header: "D4910 Perio Maint",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "total_perio_procedures",
        header: "Total Perio Procedures",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
          }),
      },
      {
        accessorKey: "perio_percent",
        header: "Perio Percent",
        enableSorting: true,
        Cell: ({ renderedCellValue }: any) => `${renderedCellValue}%`,
        muiTableBodyCellProps: () => ({
          sx: {
            fontWeight: "400",
            textTransform: "capitalize",
            border: "0.5px solid #E4E4E4",
          },
        }),
        muiTableFooterCellProps: {
          align: "center",
          sx: {
            ...footerStyles.sx,
            borderBottomRightRadius: "5px",
          },
        },
        Footer: ({ column }: any) =>
          ReportingFooter({
            column: column,
            agg: hygienistTableAgg,
            percent: true,
          }),
      },
    ],
    [hygienistsTableData],
  )

  return (
    <Box>
      <DateRangePicker />
      <Box
        sx={{
          m: "1.5%",
          mt: "3%",
          "& th": {
            padding: "0.5rem 0",
            alignContent: "center",
          },
        }}
      >
        <TableHeading>Hygienist</TableHeading>
        <CommonTable
          data={hygienistsTableData || []}
          column={hygienistColumn || []}
          enableGrouping={true}
          isloading={loading}
        />
      </Box>
    </Box>
  )
}

export default HygienistsTable
